import React from 'react'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'

// components
import {
  CSmartTable,
  CButton,
  CImage,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CSmartPagination,
} from '@coreui/react-pro'

// icons
import ThreeDotsIconMenu from '../assets/icons/ThreeDotsOptionsIcon.png'

// styling
import { styleButtonVars5 } from './custom-styles/buttonStyles'

const AppTable = ({
  clientVoucherListPage,
  gameVoucherListPage,
  gameListPage,
  claimHistoryListPage,
  setShowConfirmDelete,
  selectable,
  tableColumns,
  tableContent,
  contentPerPage,
  activeContentPage,
  contentCount,
  setActiveContentPage,
  tableFilter,
  searchContentFilter,
  setSearchContentFilter,
  setContentPerPage,
  columnContentSorter,
  setColumnContentSorter,
  isLoading,
  isShowPagination = true,
  isShowDropdownMenu = true,
  isShowColumnFilter = false
}) => {
  const navigate = useNavigate()

  return (
    <>
      <CSmartTable
        columns={tableColumns}
        columnFilter={ isShowColumnFilter ? { external: true } : false}
        columnSorter={{ multiple: true, resetable: true }}
        sorterValue={columnContentSorter}
        items={tableContent}
        itemsPerPage={contentPerPage}
        itemsPerPageSelect={isShowPagination}
        onItemsPerPageChange={(itemsPerPage) => setContentPerPage(itemsPerPage)}
        tableProps={{
          className: 'app-table-content-list',
          hover: true,
          responsive: true,
          style: {
            cursor: 'pointer'
          }
        }}
        tableHeadProps={{
          className: 'app-table-header'
        }}
        loading={isLoading}
        selectable={selectable}
        onRowClick={(item) => handleOnRowClick(item)}
        tableFilter={tableFilter}
        tableFilterValue={searchContentFilter}
        tableFilterPlaceholder='Search...'
        tableFilterLabel='Search:'
        onTableFilterChange={(filter) => setSearchContentFilter(filter)}
        onSorterChange={(value) => setColumnContentSorter(value)}
        scopedColumns={{
          expired_date: (item) => (
            <td>
              {moment(item?.expired_date).format('DD/MM/YYYY')}
            </td>
          ),
          createdAt: (item) => (
            <td>
              {moment(item?.createdAt).format('DD/MM/YYYY')}
            </td>
          ),
          action: (item, index) => (
            <td>
              <CDropdown>
                <CButton
                  style={styleButtonVars5}
                  onClick={() => {
                    let urlView = 
                      clientVoucherListPage ? `/client-voucher/details/${item.id}`
                        : gameVoucherListPage ? `/game-voucher/details/${item.id}`
                          : gameListPage ? `/game/details/${item.id}`
                            : claimHistoryListPage ? `/claim-history/details/${item.id}`
                              : null

                    navigate(urlView)
                  }}
                >
                  View
                </CButton>
                {
                  isShowDropdownMenu && (
                    <>
                      <CDropdownToggle
                        color="white"
                        caret={false}
                        style={{
                          border: "none",
                          boxShadow: "none",
                          background: "#FFF",
                          borderBottomRightRadius: ".3rem",
                          borderTopRightRadius: ".3rem",
                        }}
                        split
                      >
                        <CImage fluid src={ThreeDotsIconMenu} />
                      </CDropdownToggle>
                      <CDropdownMenu>
                        <CDropdownItem
                          onClick={() => {
                            let urlEdit = clientVoucherListPage ? `/client-voucher/edit/${item.id}`
                              : gameVoucherListPage ? `/game-voucher/edit/${item.id}`
                                : gameListPage ? `/game/edit/${item.id}`
                                  : null

                            navigate(urlEdit)
                          }}
                        >
                          Edit {
                            clientVoucherListPage ? 'Client Voucher'
                              : gameVoucherListPage ? 'Game Voucher'
                                : gameListPage ? 'Game'
                                  : ''
                          }
                        </CDropdownItem>
                        <CDropdownItem
                          onClick={() => setShowConfirmDelete({ show: true, type: clientVoucherListPage ? 'client-voucher' : gameVoucherListPage ? 'game-voucher' : gameListPage ? 'game' : '' , item: item, index })}
                        >
                          Delete {
                            clientVoucherListPage ? 'Client Voucher'
                              : gameVoucherListPage ? 'Game Voucher'
                                : gameListPage ? 'Game'
                                  : ''
                          }
                        </CDropdownItem>
                      </CDropdownMenu>
                    </>
                  )
                }
              </CDropdown>
            </td>
          )
        }}
      />
      {
        isShowPagination && (
          <CSmartPagination
            align="center"
            activePage={activeContentPage}
            pages={Math.ceil(contentCount / contentPerPage) || 1}
            onActivePageChange={(activePage) => setActiveContentPage(activePage)}
            p
          />
        )
      }
    </>
  )
}

export default AppTable
